import React from 'react';

/**
 * The public customer-chat route uses the platform's active AI configuration;
 * the legacy per-agent provider/model columns do not select that runtime.
 * Never present those stored values as though they are live configuration.
 */
const AgentRuntimeBadges = () => (
  <span
    className="rounded bg-sky-100 px-2 py-0.5 text-xs text-sky-700 dark:bg-sky-900/30 dark:text-sky-300"
    title="The customer-chat AI runtime is managed by Serviti"
  >
    Serviti-managed AI
  </span>
);

export default AgentRuntimeBadges;
